import React, { useState, useEffect } from "react";
import CustomFilters from "../../core/custom-filters";
import SiAutocomplete from "../../core/si-autocomplete";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { PAGE_LIMIT } from "../../utils";

const UserFilters = ({ loadData }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [userList, setUserList] = useState([]);
  let userTimeout = null;

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          payload[key] = filters[key];
        }
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
      });
    } else {
      loadData({ sortBy: "-createdAt", limit: PAGE_LIMIT, page: 1 });
    }
  };

  const filterTypes = [
    { label: "Filter by Name", value: "name" },
    { label: "Filter by Email", value: "email" },
  ];
  const loadUserOptions = async (inputValue, type) => {
    try {
      const response = await plainApi(
        HTTP_METHODS.GET,
        `${HOSTNAME}${REST_URLS.SEARCH_USER}`,
        null,
        { searchTerm: inputValue }
      );
      const data = response || [];
      if (type === "name") {
        setUserList(
          data.map((item) => ({
            label: item.name,
            value: item.name,
          }))
        );
      }
      if (type === "email") {
        setUserList(
          data.map((item) => ({
            label: item.email,
            value: item.email,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching ticket options:", error);
    }
  };
  const handleUserSearch = (newInputValue, type) => {
    clearTimeout(userTimeout);
    if (newInputValue) {
      userTimeout = setTimeout(() => loadUserOptions(newInputValue, type), 300);
    }
  };
  const renderFilterInput = () => {
    switch (filterType) {
      case "name":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={userList}
            placeholder="Search User Name"
            onInputChange={(newInputValue) =>
              handleUserSearch(newInputValue, "name")
            }
          />
        );
      case "email":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={userList}
            placeholder="Search User Email"
            onInputChange={(newInputValue) =>
              handleUserSearch(newInputValue, "email")
            }
          />
        );
      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default UserFilters;
